// Unpublished Work © 2023-2024 Deere & Company.

export const PROFILE_PIC_PATTERN = /profilePic_([^.]+)/;
const PLAYBOOK_UUID_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}';
const PLAYBOOK_OLD_URL_PATTERN = `^[^:/?#]+:\\/\\/[^/?#]+[^?#]*\\?courseurl=${PLAYBOOK_UUID_PATTERN}$`;
const PLAYBOOK_NEW_URL_PATTERN = `^[^:/?#]+:\\/\\/[^/?#]+\\/[^/?#]+\\/${PLAYBOOK_UUID_PATTERN}$`;

export const PLAYBOOK_URL_PATTERN = `${PLAYBOOK_OLD_URL_PATTERN}|${PLAYBOOK_NEW_URL_PATTERN}`;
